import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { getScopeContainer } from '../../utils/scopeElement';

// Drop-in replacement for react-bootstrap's OverlayTrigger. It portals its
// overlay to document.body by default, which escapes .star3e-scope and loses
// its styling - this defaults it to the app's own scoped root instead.
const ScopedOverlayTrigger = (props) => <OverlayTrigger container={getScopeContainer} {...props} />;

export default ScopedOverlayTrigger;
